import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-preisebene-list-view',
  imports: [],
  templateUrl: './preisebene.list-view.html',
  styleUrls: ['./preisebene.list-view.css'],
})
export class PreisebeneListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
